import { Home, Activity, ShoppingCart } from 'react-feather'

export default [
  {
    // id: 'sites',
    // title: 'Sites',
    // icon: <Home />,
    // children: [
    //   {
        id: 'domains',
        title: 'Domains',
        icon: <Activity />,
        navLink: '/domains'
      // }
    // ]
  }
]
